<template>
  <div class="flex-none border-b border-neutral-light bg-white">
    <div class="flex items-center gap-2 sm:gap-3 px-4 py-2.5">
      <!-- Type tabs -->
      <div class="flex items-center gap-1 flex-none overflow-x-auto">
        <button
          v-for="tab in typeTabs"
          :key="tab.value"
          class="px-3 sm:px-4 py-1.5 rounded-full text-sm font-bold transition whitespace-nowrap"
          :class="currentType === tab.value ? 'bg-primary-dark text-white' : 'bg-neutral-light text-neutral-dark hover:bg-gray-200'"
          @click="$emit('update:type', tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Divider -->
      <div class="hidden sm:block w-px h-8 bg-neutral-light flex-none"></div>

      <!-- Keyword search -->
      <div class="flex-1 min-w-0 flex gap-1">
        <input
          type="text"
          :value="keyword"
          :placeholder="labels.search_placeholder"
          class="w-full px-3 py-2 border border-neutral-light rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 min-w-0"
          @input="$emit('update:keyword', $event.target.value)"
          @keydown.enter="$emit('update:keyword', $event.target.value)"
        />
        <button
          class="bg-primary-dark text-white w-9 h-9 rounded-full font-bold transition hover:bg-primary-light flex-none flex items-center justify-center"
          @click="$emit('update:keyword', keyword)"
        >
          <i class="ph ph-magnifying-glass text-lg"></i>
        </button>
      </div>

      <!-- Filters button with badge -->
      <button
        class="relative flex items-center gap-2 px-3 sm:px-4 py-2 border border-neutral-light rounded-full text-sm font-bold text-neutral-dark hover:border-primary-dark transition flex-none"
        @click="$emit('open-filters')"
      >
        <i class="ph ph-sliders-horizontal text-lg"></i>
        <span class="hidden sm:inline">{{ labels.filters }}</span>
        <span
          v-if="activeFilterCount > 0"
          class="absolute -top-1.5 -right-1.5 bg-primary-dark text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center"
        >
          {{ activeFilterCount }}
        </span>
      </button>
    </div>

    <!-- Active filter pills -->
    <div v-if="activeFilters.length > 0" class="flex items-center gap-2 px-4 pb-2.5 overflow-x-auto">
      <button
        v-for="pill in activeFilters"
        :key="pill.key"
        class="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-primary-dark/10 text-primary-dark whitespace-nowrap flex-none transition hover:bg-primary-dark/20"
        @click="$emit('remove-filter', pill.key)"
      >
        {{ pill.label }}
        <i class="ph ph-x text-xs"></i>
      </button>
      <button
        class="text-xs font-bold text-neutral-dark underline hover:text-primary-dark transition whitespace-nowrap flex-none"
        @click="$emit('clear-filters')"
      >
        {{ labels.clear_all }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  labels: { type: Object, required: true },
  currentType: { type: [String, null], default: null },
  keyword: { type: String, default: '' },
  activeFilterCount: { type: Number, default: 0 },
  activeFilters: { type: Array, default: () => [] },
});

defineEmits(['update:type', 'update:keyword', 'open-filters', 'remove-filter', 'clear-filters']);

const typeTabs = [
  { value: null, label: props.labels.type_all },
  { value: 'sale', label: props.labels.type_sale },
  { value: 'rent', label: props.labels.type_rent },
];
</script>
